export type SessionEvent = { code: string; here: string };
type Handler = (e: SessionEvent) => void;

let handler: Handler | null = null;

export function registerSessionHandler(h: Handler) {
  handler = h;
}

export function triggerSessionExpired(code: string) {
  const here =
    window.location.pathname + window.location.search + window.location.hash;
  sessionStorage.setItem("redirectAfterLogin", here);
  handler?.({ code, here });
}
